import { gql } from "@apollo/client";

export const CARD_CREATE = gql`
  mutation createCard($card: CardInput!) {
    createCard(
      card: $card,
    ) {
      card {
        id,
        cardBrand,
        last4,
        cardholderName,
        customerId,
        cardType,
        expMonth,
        expYear,
      },
      success,
      messages,
    }
  }`;
